import React, { Component } from "react";
import {
    CHART_TYPE_COLUMN,
    CHART_TYPE_LINE,
    CHART_TYPE_PIE,
    CHECKBOX,
    COMMENT,
    COLLAPSIBLE_TABLES_SUBQUESTION_DETAILS,
    CSV_QUESTION_DETAILS,
    DATE,
    DROPDOWN,
    DYNAMIC_TABLE,
    LATEST_SURVEY_TEMPLATE_NAME,
    LATEST_SURVEY_TEMPLATE_VERSION,
    MATRIX_MULTIPLE_CHOICE,
    MATRIX_SINGLE_CHOICE,
    MISSING_QUESTION_GROUPS,
    NUMBER,
    PREDEFINED_LIST,
    PROGRAM_INSTANCE_FOREIGN_IDS,
    RADIO,
    SURVEYS_BY_REPORTING_YEAR,
    STATIC_TABLE,
    TEXT,
    TOTAL
} from "../../../../ducks/collapsibleTableChart";
import { getObjectFromList, getSubQuestionModifiedId, isTypeRelevant } from "../../../../utils/TableUtils";

import PropTypes from "prop-types";
import Accordion from "react-bootstrap/Accordion";
import Alert from "react-bootstrap/Alert";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Row from "react-bootstrap/Row";
import Tooltip from "react-bootstrap/Tooltip";
import { FormattedMessage, injectIntl } from "react-intl";
import ModalDialogUtil from "../../../../utils/ModalDialogUtil";
import FundingAreaContainer from "../../fundingArea/FundingAreaContainer";
import CSVTypeQuestion from "./Components/CSVTypeQuestion";
import DynamicTableQuestion from "./Components/DynamicTableQuestion";
import MatrixQuestion from "./Components/MatrixQuestion";
import NumberQuestion from "./Components/NumberQuestion";
import StaticTableQuestion from "./Components/StaticTableQuestion";
import HorizontalTable from "./HorizontalTable";
import PivotTableModal from "./PivotTableModal";
import ProgramChart from "./ProgramChart";

import {
    faExclamationCircle,
    faExclamationTriangle,
    faInfoCircle,
    faQuestionCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import { Nav, NavItem, NavLink } from "react-bootstrap";
import * as uuid from "uuid";
import ObjectUtils from "../../../../utils/ObjectUtils";
import { cleanText, QuestionIcon } from "../../../../utils/QuestionUtils";
import StandardView from "../../../common/StandardView";
import { HeaderOptions } from "./Components/HeaderOptions";
import FacetSidebar from "./FacetSidebar";

const CSVArray = [TEXT, COMMENT, DATE, NUMBER, CHECKBOX, RADIO, DROPDOWN, PREDEFINED_LIST];
const notExpandableArray = [];
const optionsArray = [CHECKBOX, RADIO, PREDEFINED_LIST, DROPDOWN, DATE, TEXT, COMMENT];
const tableArray = [STATIC_TABLE, DYNAMIC_TABLE];
const GROUP_BY_PROJECT_COLUMN_KEY = "project";
const GROUP_BY_REGION_COLUMN_KEY = "region";
const GROUP_BY_COUNTRY_COLUMN_KEY = "country";
const GROUP_BY_REPORTING_YEAR_QUESTION_TITLE = "Berichtszeitraum";

export class CollapsibleTableChart extends Component {
    constructor(props) {
        super(props);
        this.handleProgramInstanceSelect = this.handleProgramInstanceSelect.bind(this);
        this.handleSelectStatus = this.handleSelectStatus.bind(this);
        this.getActiveTabDynamic = this.getActiveTabDynamic.bind(this);
        this.getActiveTabStatic = this.getActiveTabStatic.bind(this);
        this.handleSelectTimeFacet = this.handleSelectTimeFacet.bind(this);
        this.handleSelectProgramInstanceFacet = this.handleSelectProgramInstanceFacet.bind(this);
        this.handleProgramSelect = this.handleProgramSelect.bind(this);
        this.handleClickQuestionGroup = this.handleClickQuestionGroup.bind(this);
        this.handleClickDownload = this.handleClickDownload.bind(this);
        this.handleClickDownloadZip = this.handleClickDownloadZip.bind(this);
        this.handleClickDownloadPdf = this.handleClickDownloadPdf.bind(this);
        this.handleClickDownloadTexts = this.handleClickDownloadTexts.bind(this);
        this.handleClickDownloadDynamicTable = this.handleClickDownloadDynamicTable.bind(this);
        this.handleClickDownloadPivotQuestion = this.handleClickDownloadPivotQuestion.bind(this);
        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.handleModalSubmit = this.handleModalSubmit.bind(this);
        this.handlePivotShortcutSubmit = this.handlePivotShortcutSubmit.bind(this);
        this.handleBeginningClick = this.handleBeginningClick.bind(this);
        this.handleModalOnGroupSelect = this.handleModalOnGroupSelect.bind(this);
        this.handleModalOnQuestionSelect = this.handleModalOnQuestionSelect.bind(this);
        this.handleModalOnTableSelect = this.handleModalOnTableSelect.bind(this);
        this.handleModalFieldSelect = this.handleModalFieldSelect.bind(this);
        this.handleModalOnMatrixSelect = this.handleModalOnMatrixSelect.bind(this);
        this.handleModalOnStaticTableTypeSelect = this.handleModalOnStaticTableTypeSelect.bind(this);
        this.handlePercentageClick = this.handlePercentageClick.bind(this);
        this.handleDynamicTableTabClick = this.handleDynamicTableTabClick.bind(this);
        this.handleStaticTableModeChange = this.handleStaticTableModeChange.bind(this);
        this.handleApplyFilterCriteria = this.handleApplyFilterCriteria.bind(this);
        this.renderSections = this.renderSections.bind(this);
        this.renderTables = this.renderTables.bind(this);
        this.renderComplexQuestions = this.renderComplexQuestions.bind(this);
        this.renderDynamic = this.renderDynamic.bind(this);
        this.renderStatic = this.renderStatic.bind(this);
        this.renderMidComplexQuestions = this.renderMidComplexQuestions.bind(this);
        this.renderHeader = this.renderHeader.bind(this);
        this.renderChart = this.renderChart.bind(this);
        this.renderPivotBreadcrumb = this.renderPivotBreadcrumb.bind(this);
        this.getBreadcrumbPath = this.getBreadcrumbPath.bind(this);
        this.getQuestionPath = this.getQuestionPath.bind(this);
        this.getQuestionKeysForGroup = this.getQuestionKeysForGroup.bind(this);

        this.state = {
            status: "SENT",
            tabActive: 0,
            questionActive: 0,
            staticTables: [],
            chartMode: {},
            showModal: false,
            pivotShortcut: {},
            percentage: {},
            submitNeeded: false,
            printConfig: null,
            programRefreshNeeded: false,
            pendingQuestionGroupDataRefresh: null
        };
    }

    componentDidMount() {
        this.props.getTimeFacetForEvaluation();
    }

    componentDidUpdate(prevProps) {
        const {
            loadQuestionGroups,
            loadQuestionGroupData,
            propertyChange,
            getChartConfig,
            chartConfig,
            timeFacet,
            label,
            currentActivePage,
            removeTableDetails,
            selectedProgramInstance,
            selectedProgram,
            selectedFundingArea,
            questionGroups,
            missingQuestionGroups
        } = this.props;

        const selectedProgramInstanceId =
            selectedProgramInstance && selectedProgramInstance.indicatorsModalDialog
                ? selectedProgramInstance.indicatorsModalDialog.id
                : null;
        const selectedProgramId =
            selectedProgram && selectedProgram.indicatorsModalDialog ? selectedProgram.indicatorsModalDialog.id : null;
        const oldSelectedProgramInstanceId =
            prevProps.selectedProgramInstance && prevProps.selectedProgramInstance.indicatorsModalDialog
                ? prevProps.selectedProgramInstance.indicatorsModalDialog.id
                : null;
        const oldSelectedProgramId =
            prevProps.selectedProgram && prevProps.selectedProgram.indicatorsModalDialog
                ? prevProps.selectedProgram.indicatorsModalDialog.id
                : null;
        const selectedFundingAreaId =
            selectedFundingArea && selectedFundingArea.indicatorsModalDialog
                ? selectedFundingArea.indicatorsModalDialog.id
                : null;
        const selectedFundingAreaForeignId =
            selectedFundingArea && selectedFundingArea.indicatorsModalDialog
                ? selectedFundingArea.indicatorsModalDialog.foreignId
                : null;
        const oldSelectedFundingAreaId =
            prevProps.selectedFundingArea && prevProps.selectedFundingArea.indicatorsModalDialog
                ? prevProps.selectedFundingArea.indicatorsModalDialog.id
                : null;
        const {status} = this.state;
        const selectedFacets = timeFacet?.facets.filter((facet) => label.indexOf(facet.label) > -1);
        const questionGroupsChanged =
            prevProps.questionGroups !== questionGroups || prevProps.missingQuestionGroups !== missingQuestionGroups;

        if (_.isEmpty(chartConfig)) {
            getChartConfig();
        }

        if (this.state.pendingQuestionGroupDataRefresh && questionGroupsChanged) {
            const pageKey = this.state.pendingQuestionGroupDataRefresh;
            loadQuestionGroupData(pageKey, this.getQuestionKeysForGroup(pageKey, questionGroups), status, selectedFacets);
            this.setState({pendingQuestionGroupDataRefresh: null});
        }

        if (selectedFundingAreaForeignId && selectedFundingAreaForeignId === "AMON" && !selectedProgramId) {
            if (selectedFundingAreaId !== oldSelectedFundingAreaId) {
                propertyChange("questionList", null);
                propertyChange("currentActivePage", null);
                loadQuestionGroups(selectedFundingAreaId, selectedProgramId, selectedProgramInstanceId, status,
                    selectedFacets);
            }
        } else if (!selectedProgramId) {
            propertyChange("questionGroups", null);
            propertyChange(MISSING_QUESTION_GROUPS, null);
            propertyChange("projectCount", null);
            propertyChange(LATEST_SURVEY_TEMPLATE_NAME, null);
            propertyChange(LATEST_SURVEY_TEMPLATE_VERSION, null);
            propertyChange(SURVEYS_BY_REPORTING_YEAR, null);
            propertyChange("currentActivePage", null);
            propertyChange("questionList", null);
        } else if (selectedProgramId !== oldSelectedProgramId) {
            propertyChange("questionList", null);
            propertyChange("currentActivePage", null);
            loadQuestionGroups(selectedFundingAreaId, selectedProgramId, selectedProgramInstanceId, status,
                selectedFacets);
        } else if (selectedProgramInstanceId !== oldSelectedProgramInstanceId) {
            propertyChange("questionList", null);
            removeTableDetails();
            if (currentActivePage) {
                this.setState({pendingQuestionGroupDataRefresh: currentActivePage});
            }
            loadQuestionGroups(selectedFundingAreaId, selectedProgramId, selectedProgramInstanceId, status,
                selectedFacets);
        }

        const startConversionJustBecameTrue =
            !prevProps.startConversion && this.props.startConversion;

        const templatesJustBecameAvailable =
            Object.keys(prevProps.surveyTemplates || {}).length === 0 &&
            Object.keys(this.props.surveyTemplates || {}).length > 0;

        if (
            this.props.startConversion &&
            Object.keys(this.props.surveyTemplates || {}).length > 0 &&
            (startConversionJustBecameTrue || templatesJustBecameAvailable)
        ) {
            this.props.convertPDFsAndZip(this.state.printConfig);
        }
    }

    /**
     * checks for the active tab in dynamic tables
     * @param table the table
     * @returns {string}
     */
    getActiveTabDynamic(table) {
        let active = table.questionId;
        table.anwser.anwserList.forEach((column) => {
            let colId;
            let rowId;
            let colKey;
            let rowKey;
            let identifier;
            if (column && column.tableIdentifier) {
                colId = column.tableIdentifier.colId;
                rowId = column.tableIdentifier.rowId;
                colKey = column.tableIdentifier.columnKey;
                rowKey = column.tableIdentifier.rowKey;
                identifier =
                    colKey || rowKey
                        ? colKey
                            ? colKey.toString()
                            : "" + rowKey
                                ? rowKey.toString()
                                : ""
                        : (colId ? colId.toString() : "0") + (rowId ? rowId.toString() : "0");
            }
            let subquestionModifiedId = getSubQuestionModifiedId(table.questionId, identifier, rowId, colId);
            if (this.state.tabActive === subquestionModifiedId) {
                active = subquestionModifiedId;
            }
        });

        return active;
    };

    /**
     * check for the active tab in static tables
     * @param table the table
     * @returns {string}
     */
    getActiveTabStatic(table, cols) {
        let tabActive = table.questionId;
        if (table.anwser?.anwserList?.length > 0) {
            if (
                table.anwser.anwserList[0].anwserList?.length > 0 &&
                table.anwser.anwserList[0].anwserList[0].tableIdentifier
            ) {
                const colId = table.anwser.anwserList[0].anwserList[0].tableIdentifier.colId;
                const rowId = table.anwser.anwserList[0].anwserList[0].tableIdentifier.rowId;
                let identifier;
                if (cols) {
                    identifier = table.anwser.anwserList[0].anwserList[0].tableIdentifier.columnKey;
                } else {
                    identifier = table.anwser.anwserList[0].anwserList[0].tableIdentifier.rowKey;
                }
                tabActive =
                    table.questionId.toString() +
                    (identifier && identifier !== ""
                        ? identifier
                        : (colId ? colId.toString() : "0") + (rowId ? rowId.toString() : "0"));
            }
        }

        table.anwser.anwserList.forEach((row) => {
            row.anwserList?.forEach((column) => {
                let colId;
                let rowId;
                let identifier;
                if (column && column.tableIdentifier) {
                    colId = column.tableIdentifier.colId;
                    rowId = column.tableIdentifier.rowId;
                    if (cols) {
                        identifier = column.tableIdentifier.columnKey;
                    } else {
                        identifier = column.tableIdentifier.rowKey;
                    }
                }
                let subquestionModifiedId = getSubQuestionModifiedId(table.questionId, identifier, rowId, colId);
                if (String(this.state.tabActive) === String(subquestionModifiedId)) {
                    tabActive = subquestionModifiedId;
                }
            });
        });

        return tabActive;
    };

    handleSelectStatus(event) {
        const selected = event.target.checked;

        const status = selected ? "SENT" : undefined;

        this.setState({status});
        this.setState({submitNeeded: true});
    }

    handleProgramInstanceSelect(value) {
        this.setState({programRefreshNeeded: value});
    }

    handleSelectTimeFacet(event) {
        const {labelChange} = this.props;
        const selected = event.target.checked;
        const targetYear = event.target.value;
        let selectedYears = this.props.label ? [...this.props.label] : [];

        if (selected) {
            selectedYears.push(targetYear);
        } else {
            selectedYears = selectedYears.filter((year) => year !== targetYear);
        }
        labelChange(selectedYears);

        this.setState({submitNeeded: true});
    }

    handleSelectProgramInstanceFacet(event, allProgramInstances) {
        const {
            propertyChange,
            programInstanceForeignIds
        } = this.props;

        let selectedInstanceIds = programInstanceForeignIds ? [...programInstanceForeignIds] : [];

        if (allProgramInstances) {
            propertyChange(
                PROGRAM_INSTANCE_FOREIGN_IDS,
                allProgramInstances.map((pi) => pi.id)
            );
            this.setState({submitNeeded: true});
        } else {
            const selected = event.target.checked;
            const id = event.target.value;

            if (selected) {
                selectedInstanceIds.push(id);
            } else {
                selectedInstanceIds = selectedInstanceIds.filter((instanceId) => instanceId !== id);
            }

            propertyChange(PROGRAM_INSTANCE_FOREIGN_IDS, selectedInstanceIds);
            if (selectedInstanceIds.length) {
                this.setState({submitNeeded: true});
            }
        }
    }

    handleProgramSelect(programInstances) {
        const {propertyChange} = this.props;

        const programInstanceIds = programInstances.map((instance) => {
            return instance.id;
        });
        propertyChange(PROGRAM_INSTANCE_FOREIGN_IDS, programInstanceIds);
        this.setState({submitNeeded: true});
    }

    handleClickQuestionGroup(pageKey) {
        const {
            loadQuestionGroupData,
            timeFacet,
            label,
            questionGroups,
            clearSinceBeginning,
            propertyChange,
            removeTableDetails
        } = this.props;
        const {status} = this.state;
        this.setState({
            activeQuestionGroup: pageKey
        });

        const selectedFacets = timeFacet?.facets.filter((facet) => label.indexOf(facet.label) > -1);

        clearSinceBeginning();
        propertyChange(CSV_QUESTION_DETAILS, []);
        propertyChange(COLLAPSIBLE_TABLES_SUBQUESTION_DETAILS, []);
        removeTableDetails();

        loadQuestionGroupData(pageKey, this.getQuestionKeysForGroup(pageKey, questionGroups), status, selectedFacets);
    }

    handleClickDownload() {
        const {
            downloadProgramCSV,
            timeFacet,
            label
        } = this.props;

        const {status} = this.state;

        const selectedFacets = timeFacet?.facets.filter((facet) => label.indexOf(facet.label) > -1);

        downloadProgramCSV(status, selectedFacets);
    }

    handleClickDownloadZip() {
        const {
            downloadProgramCSV,
            timeFacet,
            label
        } = this.props;

        const {status} = this.state;

        const selectedFacets = timeFacet?.facets.filter((facet) => label.indexOf(facet.label) > -1);

        downloadProgramCSV(status, selectedFacets, "", "", undefined, true);
    }

    handleClickDownloadPdf(printConfig) {
        const {
            downloadProjectsPdfArchive,
            timeFacet,
            label
        } = this.props;

        const {status} = this.state;

        if (printConfig) {
            this.setState({printConfig: printConfig});
        }

        const selectedFacets = timeFacet?.facets.filter((facet) => label.indexOf(facet.label) > -1);

        downloadProjectsPdfArchive(status, selectedFacets, "RUECK" === printConfig);
    }

    handleClickDownloadTexts() {
        const {
            downloadProgramCSV,
            timeFacet,
            label
        } = this.props;

        const {status} = this.state;

        const selectedFacets = timeFacet?.facets.filter((facet) => label.indexOf(facet.label) > -1);

        downloadProgramCSV(status, selectedFacets, "Comment");
    }

    handleClickDownloadDynamicTable(questionId, questionTitle) {
        const {
            downloadProgramCSV,
            timeFacet,
            label
        } = this.props;

        const {status} = this.state;

        const selectedFacets = timeFacet?.facets.filter((facet) => label.indexOf(facet.label) > -1);

        downloadProgramCSV(status, selectedFacets, "DynamicTable", questionTitle, questionId);
    }

    handleClickDownloadPivotQuestion(
        data,
        baseQuestionId,
        subquestionModifiedId,
        baseQuestionString,
        groupByQuestionString
    ) {
        const { label, selectedProgram, sinceBeginning } = this.props;

        const csv = [];
        csv.push(
            `Ausgewähltes Programm;${
                selectedProgram?.indicatorsModalDialog
                    ? selectedProgram.indicatorsModalDialog.name
                    : "k.A."
            }`
        );
        csv.push(`Ausgewählte Berichtsjahre;${label.join(", ")}`);
        csv.push(`Auswertung seit Förderbeginn?;${sinceBeginning[baseQuestionId] ? "Ja" : "Nein"}`);
        csv.push(`Ausgewählte Frage;${baseQuestionString || "k.A."}`);
        csv.push(`gekreuzt mit;${groupByQuestionString || "k.A."}`);

        const container = document.querySelector(`#table_${subquestionModifiedId}`);
        const rows = container.querySelectorAll("tr");
        function isNumeric(value) {
            return /^-?\d+(\.\d+)?$/.test(value);
        }
        for (let i = 0; i < rows.length; i++) {
            const row = [];
            const cols = rows[i].querySelectorAll("td, th");

            for (let j = 0; j < cols.length; j++) {
                let result = cols[j].innerText || "";

                if (isNumeric(result)) {
                    // Punkt → Komma für Excel DE
                    result = result.replace(".", ",");
                    row.push(result);
                } else {
                    result = result.replace(/"/g, '""');
                    result = `"${result}"`;
                    row.push(result);
                }
            }

            csv.push(row.join(";"));
        }

        const csvContent = "\uFEFF" + csv.join("\r\n");

        const FileSaver = require("file-saver");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const fileName = cleanText(ObjectUtils.trunc(baseQuestionString, 70));

        FileSaver.saveAs(blob, fileName + ".csv");
    }

    /**
     * Modal Handlers
     **/

    handleModalOpen(
        element,
        question,
        questionId,
        columnType,
        isSubquestion,
        questionType,
        rowId,
        colId,
        identifier,
        questionKey,
        rowKey,
        columnKey,
        questionGroupKey
    ) {
        const {
            setModalParameter,
            modalSelectParameters
        } = this.props;
        const {status} = this.state;
        let subquestionModifiedId = getSubQuestionModifiedId(questionId, identifier, rowId, colId);

        const baseParameters = {
            baseQuestionKey: questionKey,
            baseQuestionGroupKey: questionGroupKey,
            baseQuestionColumnKey: columnKey,
            baseQuestionRowKey: rowKey,
            baseColumnType: columnType,
            isSubquestion: isSubquestion,
            baseQuestionType: questionType,
            baseQuestionId: questionId,
            baseQuestionColId: colId,
            baseQuestionRowId: rowId,
            baseQuestionIdentifier: identifier,
            status: status
        };
        // only write on first open
        if (!modalSelectParameters[subquestionModifiedId] || modalSelectParameters[subquestionModifiedId]?.pivotShortcut) {
            setModalParameter(baseParameters, subquestionModifiedId);
        }
        this.setState({
            pivotModalActiveQuestionId: subquestionModifiedId
        });
        document.body.classList.add("modal-open");
        this.setState({showModal: true});
    }

    handleModalClose() {
        ModalDialogUtil.closeModalDialogBodyFix();
        this.setState({showModal: false});
    }

    handleModalSubmit(event, id, years, resetShortcut, latestSelected) {
        const {
            timeFacet,
            label,
            loadTableDetails,
            loadTableSubquestionDetails,
            modalSelectParameters,
            removeTableDetails,
            sinceBeginning
        } = this.props;
        const {status} = this.state;
        const questionId = id ? id : this.state.pivotModalActiveQuestionId;
        const parameter = modalSelectParameters[questionId];
        const selectedFacets = years ? years : timeFacet?.facets.filter((facet) => label.indexOf(facet.label) > -1);
        let pivotShortcuts = this.state.pivotShortcut;
        if (parameter && parameter.groupByQuestion.questionKey) {
            if (parameter.isSubquestion) {
                // remove existing data if in state
                let subquestionModifiedId = getSubQuestionModifiedId(
                    parameter.baseQuestionId,
                    parameter.baseQuestionIdentifier,
                    parameter.baseQuestionRowId,
                    parameter.baseQuestionColId
                );

                removeTableDetails(subquestionModifiedId);
                if (resetShortcut) {
                    pivotShortcuts[subquestionModifiedId] = null;
                }
                this.setState({pivotShortcut: pivotShortcuts});
                // query new data
                if (parameter.pivotStaticTableChoice && parameter.pivotStaticTableChoice === "cols") {
                    loadTableSubquestionDetails(
                        parameter.baseQuestionId,
                        parameter.baseQuestionKey,
                        parameter.baseQuestionColId,
                        parameter.baseQuestionRowId,
                        parameter.baseQuestionColumnKey,
                        parameter.baseQuestionRowKey,
                        parameter.baseQuestionGroupKey,
                        parameter.baseQuestionIdentifier,
                        parameter.baseColumnType,
                        parameter.baseQuestionType,
                        status,
                        selectedFacets,
                        parameter.groupByQuestion.questionKey,
                        parameter.groupByQuestion.questionType,
                        parameter.groupByColumnType,
                        parameter.groupByColumnKey,
                        null,
                        latestSelected !== undefined ? latestSelected : sinceBeginning[parameter.baseQuestionId],
                        this.state.staticTables[parameter.baseQuestionId] === "row"
                    );
                } else if (parameter.pivotStaticTableChoice && parameter.pivotStaticTableChoice === "rows") {
                    loadTableSubquestionDetails(
                        parameter.baseQuestionId,
                        parameter.baseQuestionKey,
                        parameter.baseQuestionColId,
                        parameter.baseQuestionRowId,
                        parameter.baseQuestionColumnKey,
                        parameter.baseQuestionRowKey,
                        parameter.baseQuestionGroupKey,
                        parameter.baseQuestionIdentifier,
                        parameter.baseColumnType,
                        parameter.baseQuestionType,
                        status,
                        selectedFacets,
                        parameter.groupByQuestion.questionKey,
                        parameter.groupByQuestion.questionType,
                        parameter.groupByColumnType,
                        null,
                        parameter.groupByRowKey,
                        latestSelected !== undefined ? latestSelected : sinceBeginning[parameter.baseQuestionId],
                        this.state.staticTables[parameter.baseQuestionId] === "row"
                    );
                } else {
                    loadTableSubquestionDetails(
                        parameter.baseQuestionId,
                        parameter.baseQuestionKey,
                        parameter.baseQuestionColId,
                        parameter.baseQuestionRowId,
                        parameter.baseQuestionColumnKey,
                        parameter.baseQuestionRowKey,
                        parameter.baseQuestionGroupKey,
                        parameter.baseQuestionIdentifier,
                        parameter.baseColumnType,
                        parameter.baseQuestionType,
                        status,
                        selectedFacets,
                        parameter.groupByQuestion.questionKey,
                        parameter.groupByQuestion.questionType,
                        parameter.groupByColumnType,
                        parameter.groupByColumnKey,
                        parameter.groupByRowKey,
                        latestSelected !== undefined ? latestSelected : sinceBeginning[parameter.baseQuestionId],
                        this.state.staticTables[parameter.baseQuestionId] === "row"
                    );
                }
            } else {
                pivotShortcuts[parameter.baseQuestionId] = null;
                this.setState({pivotShortcut: pivotShortcuts});
                loadTableDetails(
                    parameter.baseQuestionId,
                    parameter.baseQuestionKey,
                    parameter.baseQuestionGroupKey,
                    parameter.baseQuestionColumnKey,
                    parameter.baseQuestionRowKey,
                    status,
                    selectedFacets,
                    parameter.groupByQuestion.questionKey,
                    parameter.groupByColumnKey,
                    parameter.groupByRowKey,
                    latestSelected !== undefined ? latestSelected : sinceBeginning[parameter.baseQuestionId]
                );
            }

            this.setState({activeQuestion: questionId});
        }
        ModalDialogUtil.closeModalDialogBodyFix();
        this.setState({showModal: false});
    }

    handlePivotShortcutSubmit(
        baseQuestionId,
        baseQuestionColId,
        baseQuestionRowId,
        baseQuestionIdentifier,
        baseColumnType,
        isSubquestion,
        baseQuestionType,
        baseQuestionKey,
        baseQuestionRowKey,
        baseQuestionColumnKey,
        baseQuestionGroupKey,
        groupByQuestionKey,
        groupByColumnKey,
        groupByQuestionTitle,
        groupByQuestionType,
        groupByColumnType,
        status
    ) {
        const {
            timeFacet,
            label,
            loadTableDetails,
            loadTableSubquestionDetails,
            removeTableDetails,
            setModalParameter,
            sinceBeginning
        } = this.props;
        const selectedFacets = timeFacet?.facets.filter((facet) => label.indexOf(facet.label) > -1);

        const parameters = {
            baseColumnType: baseColumnType,
            baseQuestionType: baseQuestionType,
            baseQuestionId: baseQuestionId,
            baseQuestionColId: baseQuestionColId,
            baseQuestionRowId: baseQuestionRowId,
            baseQuestionKey: baseQuestionKey,
            baseQuestionGroupKey: baseQuestionGroupKey,
            baseQuestionColumnKey: baseQuestionColumnKey,
            baseQuestionRowKey: baseQuestionRowKey,
            baseQuestionIdentifier: baseQuestionIdentifier,
            isSubquestion: isSubquestion,
            pivotShortcut: groupByColumnKey,
            groupByQuestion: {
                questionTitle: groupByQuestionTitle,
                questionKey: groupByQuestionKey
            },
            groupByColumnName: groupByQuestionTitle,
            groupByColumnKey: groupByColumnKey,
            groupByColumnType: groupByColumnType,
            groupByRowKey: null,
            status: status
        };

        let pivotShortcuts = this.state.pivotShortcut;
        const pivotShortcut = {
            shortcutType: groupByColumnKey,
            path: this.getPivotShortcutPath(groupByColumnKey),
            firstColumnTitle: groupByQuestionTitle
        };

        if (isSubquestion) {
            let subquestionModifiedId = getSubQuestionModifiedId(
                baseQuestionId,
                baseQuestionIdentifier,
                baseQuestionRowId,
                baseQuestionColId
            );
            setModalParameter(parameters, subquestionModifiedId);
            pivotShortcuts[subquestionModifiedId] = pivotShortcut;
            this.setState({pivotShortcut: pivotShortcuts});
            this.setState({activeQuestion: subquestionModifiedId});

            removeTableDetails(subquestionModifiedId);
            loadTableSubquestionDetails(
                baseQuestionId,
                baseQuestionKey,
                baseQuestionColId,
                baseQuestionRowId,
                baseQuestionColumnKey,
                baseQuestionRowKey,
                baseQuestionGroupKey,
                baseQuestionIdentifier,
                baseColumnType,
                baseQuestionType,
                status,
                selectedFacets,
                groupByQuestionKey,
                groupByQuestionType,
                groupByColumnType,
                groupByColumnKey,
                null,
                sinceBeginning[baseQuestionId],
                this.state.staticTables[baseQuestionId] === "row"
            );
        } else {
            setModalParameter(parameters, baseQuestionId);
            pivotShortcuts[baseQuestionId] = pivotShortcut;
            this.setState({pivotShortcut: pivotShortcuts});
            this.setState({activeQuestion: baseQuestionId});
            loadTableDetails(
                baseQuestionId,
                baseQuestionKey,
                baseQuestionGroupKey,
                baseQuestionColumnKey,
                baseQuestionRowKey,
                status,
                selectedFacets,
                groupByQuestionKey,
                groupByColumnKey,
                null,
                sinceBeginning[baseQuestionId]
            );
        }
    }

    handleModalOnGroupSelect(e) {
        const {
            modalSelectParameters,
            loadQuestionGroupDataModal,
            setModalParameter,
            timeFacet,
            label,
            questionList
        } =
            this.props;
        const parameter = modalSelectParameters[this.state.pivotModalActiveQuestionId];
        const selectedFacets = timeFacet?.facets.filter((facet) => label.indexOf(facet.label) > -1);
        const newParameter = Object.assign({}, parameter, {
            groupByQuestionGroupKey: e.target.value,
            groupByQuestion: null,
            groupByRowKey: null,
            groupByColumnKey: null
        });
        setModalParameter(newParameter, this.state.pivotModalActiveQuestionId);
        let activeQuestion = questionList.find((q) => String(q.questionId) === String(parameter.baseQuestionId));
        loadQuestionGroupDataModal(
            e.target.value,
            this.getQuestionKeysForGroup(e.target.value, this.props.questionGroups),
            this.state.status,
            selectedFacets,
            activeQuestion,
            this.state.pivotModalActiveQuestionId
        );
    }

    handleModalOnQuestionSelect(e) {
        const {
            modalSelectParameters,
            modalSelectQuestionList,
            setModalParameter
        } = this.props;
        const parameter = modalSelectParameters[this.state.pivotModalActiveQuestionId];
        const questionList = modalSelectQuestionList[this.state.pivotModalActiveQuestionId];
        questionList.forEach((question) => {
            if (String(e.target.value) === String(question.questionKey || question.questionId)) {
                const newParameter = Object.assign({}, parameter, {
                    groupByQuestion: question,
                    groupByRowKey: null,
                    groupByColumnKey: null,
                    groupByColumnName: null,
                    firstColumnTitle: question.questionTitle
                });
                setModalParameter(newParameter, this.state.pivotModalActiveQuestionId);
            }
        });
    }

    handleModalOnTableSelect(e) {
        const {
            modalSelectParameters,
            setModalParameter
        } = this.props;
        const parameter = modalSelectParameters[this.state.pivotModalActiveQuestionId];
        let newParameter;
        const identifier = JSON.parse(e.target.value);
        newParameter = Object.assign({}, parameter, {
            groupByRowKey: identifier.groupByRowKey,
            groupByColumnKey: identifier.groupByColKey,
            groupByColumnName: identifier.name
        });
        setModalParameter(newParameter, this.state.pivotModalActiveQuestionId);
    }

    handleModalOnMatrixSelect(e) {
        const {
            modalSelectParameters,
            setModalParameter
        } = this.props;
        const parameter = modalSelectParameters[this.state.pivotModalActiveQuestionId];
        const identifier = JSON.parse(e.target.value);
        const newParameter = Object.assign({}, parameter, {
            groupByRowKey: identifier.id,
            groupByColumnName: identifier.name,
            firstColumnTitle: identifier.name
        });
        setModalParameter(newParameter, this.state.pivotModalActiveQuestionId);
    }

    handleBeginningClick(e, checked, subQuestionModifiedId) {
        const {
            collapsibleTablesDetails,
            csvQuestionDetails,
            modalSelectParameters,
            loadQuestionGroupData,
            timeFacet,
            label,
            setSinceBeginning,
            questionGroups,
            currentActivePage,
            removeTableDetails,
            propertyChange
        } = this.props;
        const {
            status,
            activeQuestionGroup
        } = this.state;
        const questionId = e.target.name;
        const questionKey = e.target.value || questionId;
        const activeGroup = activeQuestionGroup || currentActivePage;
        const activeDetailId = subQuestionModifiedId ? subQuestionModifiedId : questionId;
        const selectedFacets = timeFacet?.facets.filter((facet) => label.includes(facet.label));

        propertyChange(CSV_QUESTION_DETAILS, []);
        removeTableDetails(activeDetailId);

        if (activeGroup) {
            loadQuestionGroupData(
                activeGroup,
                this.getQuestionKeysForGroup(activeGroup, questionGroups),
                status,
                selectedFacets,
                checked ? questionKey : null,
                checked
            );
        }

        setSinceBeginning(questionId, checked);

        const detailsShown = getObjectFromList(
            collapsibleTablesDetails,
            activeDetailId
        );
        const simpleDetailsShown = String(csvQuestionDetails[0]?.questionId) === String(questionId);
        const parameters = modalSelectParameters[activeDetailId];
        if ((detailsShown || simpleDetailsShown) && parameters) {
            this.handleModalSubmit(null, activeDetailId, selectedFacets, null, checked);
        }
    }

    handleModalFieldSelect(e, question) {
        const {
            modalSelectParameters,
            setModalParameter
        } = this.props;
        let modalSelectParameter = modalSelectParameters[this.state.pivotModalActiveQuestionId];
        if (question.anwser.anwserList) {
            question.anwser.anwserList.forEach((field) => {
                if (field.questionType !== TOTAL) {
                    let colId;
                    let rowId;
                    let colKey;
                    let rowKey;
                    let identifier;
                    if (field && field.tableIdentifier) {
                        colId = field.tableIdentifier.colId;
                        rowId = field.tableIdentifier.rowId;
                        colKey = field.tableIdentifier.columnKey;
                        rowKey = field.tableIdentifier.rowKey;
                        identifier =
                            colKey || rowKey
                                ? colKey
                                    ? colKey.toString()
                                    : "" + rowKey
                                        ? rowKey.toString()
                                        : ""
                                : (colId ? colId.toString() : "0") + (rowId ? rowId.toString() : "0");
                    }

                    let subquestionModifiedId = getSubQuestionModifiedId(question.questionId, identifier, rowId, colId);
                    if (e.target.value === subquestionModifiedId) {
                        const newParameter = Object.assign({}, modalSelectParameter, {
                            groupByColumnKey: field.tableIdentifier.columnKey,
                            groupByFieldId: subquestionModifiedId,
                            groupByColumnName: field.title,
                            firstColumnTitle: field.title,
                            groupByColumnType: field.questionType
                        });
                        setModalParameter(newParameter, this.state.pivotModalActiveQuestionId);
                    }
                }
            });
        } else {
            const newParameter = Object.assign({}, modalSelectParameter, {
                groupByFieldId: question.questionId
            });
            setModalParameter(newParameter, this.state.pivotModalActiveQuestionId);
        }
    }

    handleModalOnStaticTableTypeSelect(type) {
        const {
            modalSelectParameters,
            setModalParameter
        } = this.props;
        let parameter = modalSelectParameters[this.state.pivotModalActiveQuestionId];
        const newParameter = Object.assign({}, parameter, {
            pivotStaticTableChoice: type
        });
        setModalParameter(newParameter, this.state.pivotModalActiveQuestionId);
    }

    handlePercentageClick(subquestionModifiedId, percentageOn) {
        let percentage = this.state.percentage;
        percentage[subquestionModifiedId] = percentageOn;
        this.setState({percentage});
    }

    handleDynamicTableTabClick(tabId) {
        this.setState({tabActive: tabId});
    }

    handleStaticTableModeChange(questionId, mode) {
        let stateTmp = this.state;
        stateTmp.staticTables[questionId] = mode;
        this.setState({stateTmp});
    }

    handleApplyFilterCriteria() {
        const {
            timeFacet,
            programInstanceForeignIds,
            currentActivePage,
            loadQuestionGroups,
            removeTableDetails,
            selectedFundingArea,
            selectedProgram,
            propertyChange,
            clearSinceBeginning
        } = this.props;
        const {status} = this.state;
        let selectedYears = this.props.label ? [...this.props.label] : [];
        const selectedFundingAreaId =
            selectedFundingArea && selectedFundingArea.indicatorsModalDialog
                ? selectedFundingArea.indicatorsModalDialog.id
                : null;
        const selectedProgramId =
            selectedProgram && selectedProgram.indicatorsModalDialog ? selectedProgram.indicatorsModalDialog.id : null;
        let selectedInstanceIds = programInstanceForeignIds ? [...programInstanceForeignIds] : [];

        clearSinceBeginning();
        propertyChange("questionList", null);
        propertyChange(CSV_QUESTION_DETAILS, []);
        propertyChange(COLLAPSIBLE_TABLES_SUBQUESTION_DETAILS, []);
        removeTableDetails();

        this.setState({
            submitNeeded: false,
            sinceBeginning: {},
            pendingQuestionGroupDataRefresh: currentActivePage && selectedInstanceIds.length > 0 ? currentActivePage : null
        });

        const selectedFacets = timeFacet?.facets.filter((facet) => selectedYears.indexOf(facet.label) > -1);
        loadQuestionGroups(selectedFundingAreaId, selectedProgramId, null, status, selectedFacets);
        if (currentActivePage && selectedInstanceIds.length > 0) {
            if (this.state.activeQuestion) {
                this.handleModalSubmit(null, this.state.activeQuestion, selectedFacets, false, false);
            }
        }
    }

    renderTooltips(table) {
        const {
            label,
            intl
        } = this.props;

        const tooltip = table.questionDescription && (
            <Tooltip id={`button-tooltip-${table.questionId}`}>{table.questionDescription}</Tooltip>
        );
        const warning = !this.allYearsFound(label, table) && (
            <Tooltip id={`button-warning-${table.questionId}`}>
                {intl.formatMessage({id: "collapsible.filter.reportingYear.warning"}) + " " + table.reportingPeriods}
            </Tooltip>
        );
        const titleWarning = table.titleCount > 1 && (
            <Tooltip id={`button-titlewarning-${table.questionId}`}>
                {intl.formatMessage({id: "collapsible.filter.reportingYear.warningTitle"})}
            </Tooltip>
        );

        return (
            <>
                {tooltip && (
                    <OverlayTrigger placement="bottom" overlay={tooltip}>
                        <FontAwesomeIcon icon={faQuestionCircle} className="ms-2" role="button"/>
                    </OverlayTrigger>
                )}
                {titleWarning && (
                    <OverlayTrigger placement="bottom" overlay={titleWarning}>
                        <FontAwesomeIcon
                            icon={faInfoCircle}
                            className="ms-2 text-info border-primary bg-primary border rounded-pill"
                            role="button"
                        />
                    </OverlayTrigger>
                )}
                {warning && (
                    <OverlayTrigger placement="bottom" overlay={warning}>
                        <FontAwesomeIcon
                            icon={faExclamationCircle}
                            className="ms-2 text-warning border-secondary bg-dark border rounded-pill"
                            role="button"
                        />
                    </OverlayTrigger>
                )}
            </>
        );
    }

    renderQuestionGroupTemplateInfo() {
        const {
            intl,
            latestSurveyTemplateName,
            latestSurveyTemplateVersion
        } = this.props;

        if (!latestSurveyTemplateName && (latestSurveyTemplateVersion === null || latestSurveyTemplateVersion === undefined)) {
            return null;
        }

        const tooltip = (
            <Tooltip id="question-group-template-info">
                {intl.formatMessage(
                    {id: "collapsible.table.question.group.template.info"},
                    {
                        name: latestSurveyTemplateName || "k.A.",
                        version:
                            latestSurveyTemplateVersion === null || latestSurveyTemplateVersion === undefined
                                ? "k.A."
                                : latestSurveyTemplateVersion
                    }
                )}
            </Tooltip>
        );

        return (
            <OverlayTrigger placement="right" overlay={tooltip}>
                <FontAwesomeIcon
                    icon={faInfoCircle}
                    className="ms-2 programTooltip programButtonTooltip"
                    role="button"
                />
            </OverlayTrigger>
        );
    }

    render() {
        const {
            intl,
            questionList,
            programInstanceForeignIds,
            modalSelectQuestionList,
            modalSelectParameters,
            questionGroups,
            missingQuestionGroups,
            projectCount,
            surveysByReportingYear,
            timeFacet,
            label,
            currentActivePage,
            selectedFundingArea
        } = this.props;

        const tooltip = (
            <Tooltip id={"infoTooltip"}>{intl.formatMessage({id: "collapsible.filter.reportingYear.info"})}</Tooltip>
        );

        const questionGroupsNeedRefresh =
            questionGroups && questionGroups.length === 1 && questionGroups[0].pageKey === "projectData";
        return (
            <StandardView id="collapsibleTable" titleKey="evaluation.tabs.collapsible">
                <PivotTableModal
                    modalId={"pivotModal"}
                    questionGroups={questionGroups}
                    showModal={this.state.showModal}
                    activeQuestion={this.state.pivotModalActiveQuestionId}
                    modalSelectParameters={modalSelectParameters}
                    modalSelectQuestionList={modalSelectQuestionList}
                    onGroupSelect={this.handleModalOnGroupSelect}
                    onQuestionSelect={this.handleModalOnQuestionSelect}
                    onStaticTableTypeSelect={this.handleModalOnStaticTableTypeSelect}
                    onTableSelect={this.handleModalOnTableSelect}
                    onFieldSelect={this.handleModalFieldSelect}
                    onMatrixSelect={this.handleModalOnMatrixSelect}
                    onClose={this.handleModalClose}
                    onSubmit={this.handleModalSubmit}
                />
                <FundingAreaContainer
                    target="indicatorsModalDialog"
                    preventProjectChoice
                    preventProgramInstance={true}
                    onProgramSelect={this.handleProgramSelect}
                    onProgramInstanceSelect={this.handleProgramInstanceSelect}
                    programRefreshNeeded={this.state.programRefreshNeeded}
                />
                <Row className="my-4">
                    <Col lg={2} md={2} sm={3} className="mt-n3">
                        {questionGroups &&
                            (questionGroupsNeedRefresh ? (
                                <></>
                            ) : (
                                <fieldset className="border">
                                    <legend className="w-auto px-2 ms-1">
                                        <FormattedMessage id="collapsible.table.question.group"/>
                                        {this.renderQuestionGroupTemplateInfo()}
                                    </legend>
                                    <Nav className="flex-column">{questionGroups.map(this.renderSections)}</Nav>
                                    {missingQuestionGroups?.length > 0 && (
                                        <>
                                            <div className="mt-3 mb-1 px-2 fw-bold">
                                                <FormattedMessage id="collapsible.table.question.group.previous.templates"/>
                                            </div>
                                            <Nav className="flex-column">
                                                {missingQuestionGroups.map((section, i) => this.renderSections(section, i + 1, false))}
                                            </Nav>
                                        </>
                                    )}
                                </fieldset>
                            ))}
                    </Col>
                    <Col lg={8} md={10} sm={9}>
                        {(!this.props.selectedProgram || !this.props.selectedProgram.indicatorsModalDialog) && selectedFundingArea?.indicatorsModalDialog?.name !== "Aktivitätenmonitoring" ? (
                            <Alert variant="info text-dark">
                                <FontAwesomeIcon icon={faInfoCircle} className="me-2"/>
                                <FormattedMessage id="collapsible.program.required"/>
                            </Alert>
                        ) : (!programInstanceForeignIds || programInstanceForeignIds.length === 0) && selectedFundingArea?.indicatorsModalDialog?.name !== "Aktivitätenmonitoring" ? (
                            <Alert variant="info text-dark">
                                <FontAwesomeIcon icon={faInfoCircle} className="me-2"/>
                                <FormattedMessage id="collapsible.program.instance.required"/>
                            </Alert>
                        ) : !this.props.label || this.props.label.length === 0 ? (
                            <Alert variant="info text-dark">
                                <FontAwesomeIcon icon={faInfoCircle} className="me-2"/>
                                <FormattedMessage id="collapsible.year.required"/>
                            </Alert>
                        ) : (
                            (!questionGroups || questionGroups.length === 0 || questionGroupsNeedRefresh) &&
                            !currentActivePage &&
                            !this.state.submitNeeded && (
                                <Alert variant="secondary">
                                    <FormattedMessage id="collapsible.no.question.groups.found"/>
                                </Alert>
                            )
                        )}
                        {questionGroups?.length > 0 && !questionGroupsNeedRefresh && !currentActivePage && (
                            <Alert variant="info text-dark">
                                <FontAwesomeIcon icon={faInfoCircle} className="me-2"/>
                                <FormattedMessage id="collapsible.question.group.required"/>
                            </Alert>
                        )}
                        {this.props.selectedProgram &&
                            this.props.selectedProgram.indicatorsModalDialog &&
                            this.props.label &&
                            this.props.label.length > 0 &&
                            programInstanceForeignIds &&
                            programInstanceForeignIds.length > 0 &&
                            this.state.submitNeeded && (
                                <Alert variant="warning">
                                    <FontAwesomeIcon icon={faExclamationTriangle} className="me-2"/>
                                    <FormattedMessage id="collapsible.changed.filter.criteria"/>
                                </Alert>
                            )}
                        {questionList && questionList.length > 0 ? (
                            <Accordion>{questionList.map(this.renderTables)}</Accordion>
                        ) : (
                            currentActivePage &&
                            questionGroups?.length > 0 &&
                            !questionGroupsNeedRefresh &&
                            !this.state.submitNeeded && (
                                <Alert variant="secondary">
                                    <FormattedMessage id="collapsible.table.nodata"/>
                                </Alert>
                            )
                        )}
                    </Col>
                    <Col lg={2} md={3} sm={4}>
                        <FacetSidebar
                            timeFacet={timeFacet}
                            fundingAreaList={this.props.fundingAreaList}
                            selectedFundingArea={this.props.selectedFundingArea}
                            selectedProgram={this.props.selectedProgram}
                            selectedProgramInstanceIds={programInstanceForeignIds}
                            target="indicatorsModalDialog"
                            status={this.state.status}
                            projectCount={projectCount}
                            surveysByReportingYear={surveysByReportingYear}
                            tooltip={tooltip}
                            label={label}
                            handleSelectTimeFacet={this.handleSelectTimeFacet}
                            handleSelectProgramInstanceFacet={this.handleSelectProgramInstanceFacet}
                            handleSelectStatus={this.handleSelectStatus}
                            handleClickDownload={this.handleClickDownload}
                            handleClickDownloadTexts={this.handleClickDownloadTexts}
                            handleClickDownloadZip={this.handleClickDownloadZip}
                            handleClickDownloadPdf={this.handleClickDownloadPdf}
                            handleApplyFilterCriteria={this.handleApplyFilterCriteria}
                        />
                    </Col>
                </Row>
            </StandardView>
        );
    }

    // rendering of question groups
    renderSections(section, i, showIndex) {
        const title = section.title ? section.title : section.name;

        return (
            section.pageKey !== "projectData" && (
                <NavItem key={i}>
                    <NavLink
                        active={section.pageKey === this.props.currentActivePage}
                        onClick={() => this.handleClickQuestionGroup(section.pageKey)}
                    >
                        {showIndex === false ? title : i + ". " + title}
                    </NavLink>
                </NavItem>
            )
        );
    }

    //rendering of collapsible tables
    renderTables(table, i) {
        const {
            csvQuestionDetails,
            modalSelectParameters,
            sinceBeginning,
            label,
            intl
        } = this.props;
        const {status} = this.state;
        let questionType = table.questionType;
        let allYearsFound = this.allYearsFound(label, table);
        return (
            <Accordion.Item eventKey={table.questionId} key={i} className="mb-2 border" style={{overflow: "visible"}}>
                {isTypeRelevant(questionType, CSVArray) ? (
                    <CSVTypeQuestion
                        table={table}
                        csvQuestionDetails={csvQuestionDetails}
                        modalSelectParameters={modalSelectParameters}
                        status={status}
                        label={label}
                        percentage={this.state.percentage}
                        renderChart={this.renderChart}
                        renderPivotBreadcrumb={this.renderPivotBreadcrumb}
                        renderTooltips={this.renderTooltips.bind(this)}
                        handleClickDownloadPivotQuestion={this.handleClickDownloadPivotQuestion}
                        handleModalOpen={this.handleModalOpen}
                        handlePivotShortcutSubmit={this.handlePivotShortcutSubmit}
                        handleBeginningClick={this.handleBeginningClick}
                        handlePercentageClick={this.handlePercentageClick}
                        getQuestionPath={this.getQuestionPath}
                        getBreadcrumbPath={this.getBreadcrumbPath}
                        pivotShortcut={this.state.pivotShortcut}
                        sinceBeginning={sinceBeginning}
                        allYearsFound={allYearsFound}
                        intl={intl}
                    />
                ) : isTypeRelevant(questionType, tableArray) ? (
                    this.renderComplexQuestions(table)
                ) : (
                    this.renderMidComplexQuestions(table)
                )}
            </Accordion.Item>
        );
    }

    // dynamic and static table
    renderComplexQuestions(table) {
        const {
            expandedQuestionList,
            expandComplexTable,
            collapseComplexTable,
            sinceBeginning
        } = this.props;
        let questionType = table.questionType;
        const isDynamicTable = questionType === DYNAMIC_TABLE;
        let detailsShown = expandedQuestionList.includes(table.questionId);

        const subquestionModifiedId = isDynamicTable ? this.getActiveTabDynamic(table) : this.getActiveTabStatic(table, true);
        return (
            <>
                <Accordion.Header
                    className="flex-center flex-nowrap"
                    as={Card.Header}
                    onClick={detailsShown ? () => collapseComplexTable(table.questionId) : expandComplexTable(
                        table.questionId)}
                >
                    <QuestionIcon type={questionType} className="me-2"/>
                    <span className="flex-grow-1 text-break" style={{minWidth: 0}}>
                        {table.questionTitle}
                        {this.renderTooltips(table)}
                    </span>
                    <HeaderOptions
                        table={table}
                        handleBeginningClick={this.handleBeginningClick}
                        subquestionModifiedId={subquestionModifiedId}
                        sinceBeginning={sinceBeginning}
                    />
                </Accordion.Header>
                <Accordion.Body>
                    {isDynamicTable ? this.renderDynamic(table) : this.renderStatic(table)}
                </Accordion.Body>
            </>
        );
    }

    allYearsFound(label, table) {
        const found = label.filter((value) => table.reportingPeriods.includes(value));
        return this.state.submitNeeded || (found && found.length === label.length);
    }

    //collapsible questions
    renderMidComplexQuestions(table) {
        const {
            collapsibleTablesDetails,
            modalSelectParameters,
            sinceBeginning
        } = this.props;
        let questionId = table.questionId;
        let questionType = table.questionType;
        let detailsShown = getObjectFromList(collapsibleTablesDetails, questionId);
        const parameters = modalSelectParameters[table.questionId];
        let matrix = questionType === MATRIX_SINGLE_CHOICE || questionType === MATRIX_MULTIPLE_CHOICE;

        return (
            <>
                <Accordion.Header
                    className="flex-center flex-nowrap"
                    as={Card.Header}
                >
                    <QuestionIcon type={questionType} className="me-2"/>
                    <span className="flex-grow-1 text-break" style={{minWidth: 0}}>
                        {table.questionTitle}
                        {this.renderTooltips(table)}
                    </span>
                    <HeaderOptions
                        table={table}
                        handleBeginningClick={this.handleBeginningClick}
                        subquestionModifiedId={this.state.activeQuestion}
                        sinceBeginning={sinceBeginning}
                    />
                </Accordion.Header>
                <Accordion.Body>
                    {questionType === NUMBER ? (
                        <NumberQuestion
                            table={table}
                            percentage={this.state.percentage[questionId]}
                            detailsShown={detailsShown}
                            firstColumnTitle={parameters?.groupByColumnName && detailsShown ? parameters?.groupByColumnName : null}
                            tableId={table.questionId.toString()}
                            renderStats
                        />
                    ) : isTypeRelevant(questionType, optionsArray) ? (
                        <HorizontalTable
                            data={table.anwser}
                            percentage={this.state.percentage[questionId]}
                            tableId={`table_${table.questionId}`}
                            subQuestionDetails={detailsShown}
                            key={uuid.v4()}
                            firstColumnTitle={
                                parameters?.firstColumnTitle && detailsShown
                                    ? this.state.pivotShortcut[table.questionId]?.firstColumnTitle
                                        ? this.state.pivotShortcut[table.questionId].firstColumnTitle
                                        : parameters?.firstColumnTitle
                                    : null
                            }
                            useZAxisValue={parameters?.groupByColumnKey === GROUP_BY_PROJECT_COLUMN_KEY}
                        />
                    ) : (
                        matrix && (
                            <MatrixQuestion
                                subQuestion={table}
                                collapsibleTablesDetails={collapsibleTablesDetails}
                                modalSelectParameters={modalSelectParameters}
                                renderHeader={this.renderHeader}
                                renderChart={this.renderChart}
                                renderPivotBreadcrumb={this.renderPivotBreadcrumb}
                                handleClickDownloadPivotQuestion={this.handleClickDownloadPivotQuestion}
                                handleModalOpen={this.handleModalOpen}
                                handlePivotShortcutSubmit={this.handlePivotShortcutSubmit}
                                handlePercentageClick={this.handlePercentageClick}
                                getQuestionPath={this.getQuestionPath}
                                getBreadcrumbPath={this.getBreadcrumbPath}
                                pivotShortcut={this.state.pivotShortcut}
                                percentage={this.state.percentage}
                                sinceBeginning={sinceBeginning[table.questionId] ? sinceBeginning[table.questionId] : false}
                                tabActive={this.state.tabActive + ""}
                                onTabClick={this.handleDynamicTableTabClick}
                            />
                        )
                    )}
                </Accordion.Body>
            </>
        );
    }

    // dynamic table
    renderDynamic(table) {
        const {
            expandedQuestionList,
            collapsibleTablesDetails,
            csvQuestionDetails,
            modalSelectParameters,
            label,
            sinceBeginning
        } = this.props;

        const {status} = this.state;

        return (
            expandedQuestionList.includes(table.questionId) &&
            table.anwser.anwserList.length > 0 && (
                <DynamicTableQuestion
                    table={table}
                    collapsibleTablesDetails={collapsibleTablesDetails}
                    csvQuestionDetails={csvQuestionDetails}
                    modalSelectParameters={modalSelectParameters}
                    renderHeader={this.renderHeader}
                    renderChart={this.renderChart}
                    renderPivotBreadcrumb={this.renderPivotBreadcrumb}
                    handleClickDownloadPivotQuestion={this.handleClickDownloadPivotQuestion}
                    handleModalOpen={this.handleModalOpen}
                    handlePivotShortcutSubmit={this.handlePivotShortcutSubmit}
                    handleBeginningClick={this.handleBeginningClick}
                    handlePercentageClick={this.handlePercentageClick}
                    getQuestionPath={this.getQuestionPath}
                    getBreadcrumbPath={this.getBreadcrumbPath}
                    pivotShortcut={this.state.pivotShortcut}
                    sinceBeginning={sinceBeginning}
                    status={status}
                    label={label}
                    percentage={this.state.percentage}
                    optionsArray={optionsArray}
                    getActiveTabDynamic={this.getActiveTabDynamic}
                    notExpandableArray={notExpandableArray}
                    tabActive={this.state.tabActive}
                    onTabClick={this.handleDynamicTableTabClick}
                />
            )
        );
    }

    // static table
    renderStatic(table, details) {
        const {
            expandedQuestionList,
            collapsibleTablesDetails,
            csvQuestionDetails,
            modalSelectParameters,
            label,
            sinceBeginning
        } = this.props;
        const {status} = this.state;

        return (
            <StaticTableQuestion
                table={table}
                details={details}
                expandedQuestionList={expandedQuestionList}
                percentage={this.state.percentage}
                pivotShortcut={this.state.pivotShortcut}
                chartMode={this.state.chartMode}
                sinceBeginning={sinceBeginning}
                staticTables={this.state.staticTables}
                notExpandableArray={notExpandableArray}
                optionsArray={optionsArray}
                label={label}
                collapsibleTablesDetails={collapsibleTablesDetails}
                csvQuestionDetails={csvQuestionDetails}
                modalSelectParameters={modalSelectParameters}
                status={status}
                renderHeader={this.renderHeader}
                renderChart={this.renderChart}
                onStaticTableModeChange={this.handleStaticTableModeChange}
                handleClickDownloadPivotQuestion={this.handleClickDownloadPivotQuestion}
                handleModalOpen={this.handleModalOpen}
                handlePivotShortcutSubmit={this.handlePivotShortcutSubmit}
                handleBeginningClick={this.handleBeginningClick}
                handlePercentageClick={this.handlePercentageClick}
                getQuestionPath={this.getQuestionPath}
                getBreadcrumbPath={this.getBreadcrumbPath}
                renderPivotBreadcrumb={this.renderPivotBreadcrumb}
                getActiveTabStatic={this.getActiveTabStatic}
                activeTab={this.state.tabActive}
                onTabClick={this.handleDynamicTableTabClick}
            />
        );
    }

    renderHeader(detailsShown, title, questionType, subquestionModifiedId) {
        return (
            <>
                <QuestionIcon type={questionType} className="me-2"/>
                {title}
            </>
        );
    }

    renderChart(table, detailsShown, subquestionType, groupByColumnName, groupByColumnKey) {
        const {chartConfig} = this.props;
        let chartProps = detailsShown
            ? groupByColumnName === GROUP_BY_REPORTING_YEAR_QUESTION_TITLE
                ? chartConfig[CHART_TYPE_LINE]
                : (table && table.data && table.data.length > 10) || subquestionType === "CHECKBOX"
                    ? chartConfig[CHART_TYPE_COLUMN]
                    : chartConfig[CHART_TYPE_PIE]
            : (table && table.data && table.data.length > 10) || subquestionType === "CHECKBOX"
                ? chartConfig[CHART_TYPE_COLUMN]
                : chartConfig[CHART_TYPE_PIE];
        return (
            <ProgramChart
                title={groupByColumnName ? groupByColumnName : table.title}
                chartProps={chartProps}
                visualization={table}
                details={detailsShown}
                questionType={subquestionType}
                useZAxisValue={groupByColumnKey === GROUP_BY_PROJECT_COLUMN_KEY}
            />
        );
    }

    renderPivotBreadcrumb(questionId) {
        const {
            removeTableDetails,
            csvQuestionDetails,
            removeCsvQuestionDetails,
            clearModalParameter
        } = this.props;
        const path = this.getBreadcrumbPath(questionId);

        return (
            path !== "" && (
                <Alert
                    className="mb-0 w-100"
                    variant="light"
                    dismissible
                    onClose={() => {
                        if (csvQuestionDetails[0]?.questionId === questionId) {
                            removeCsvQuestionDetails();
                        } else {
                            removeTableDetails(questionId);
                        }
                        let stateTmp = this.state;
                        clearModalParameter(questionId);
                        stateTmp.pivotShortcut[questionId] = null;
                        this.setState({stateTmp});
                    }}
                >
                    {path}
                </Alert>
            )
        );
    }

    getBreadcrumbPath(questionId, parameters) {
        const {
            modalSelectParameters,
            questionGroups,
            missingQuestionGroups
        } = this.props;

        // shortcuts in state
        if (this.state.pivotShortcut[questionId]?.path) {
            return this.state.pivotShortcut[questionId]?.path;
        }

        if (!parameters) {
            parameters = modalSelectParameters[questionId];
        }
        // shortcuts in parameters
        if (parameters?.pivotShortcut) {
            return this.getPivotShortcutPath(parameters.pivotShortcut);
        }

        let group;
        [...(questionGroups || []), ...(missingQuestionGroups || [])].forEach((gr) => {
            if (gr.pageKey === parameters.groupByQuestionGroupKey) {
                group = gr;
            }
        });
        let path = "";
        if (group && parameters?.groupByQuestion?.questionTitle) {
            path += group.title + " > " + parameters.groupByQuestion.questionTitle;
            if (parameters.groupByColumnName) {
                path += " > " + parameters.groupByColumnName;
            }
        }
        return path;
    }

    getPivotShortcutPath(groupByColumnKey) {
        const labels = {
            [GROUP_BY_PROJECT_COLUMN_KEY]: "Projekt",
            [GROUP_BY_REGION_COLUMN_KEY]: "Region",
            [GROUP_BY_COUNTRY_COLUMN_KEY]: "Land"
        };
        return `Basisdaten > Projektdaten > ${labels[groupByColumnKey] || "Berichtszeitraum"}`;
    }

    getQuestionPath(question, rowCol) {
        let res = question > 70 ? question.substring(0, 70) : question;
        if (rowCol) {
            res += " > " + (rowCol > 70 ? rowCol.substring(0, 70) : rowCol);
        }
        return res;
    }

    getQuestionKeysForGroup(pageKey, questionGroups) {
        const selectedGroups = [...(questionGroups || []), ...(this.props.missingQuestionGroups || [])]
            .filter((group) => group.pageKey === pageKey);
        const questionKeys = selectedGroups
            .flatMap((group) => group.questions || [])
            .map((question) => question.questionKey)
            .filter((questionKey) => !!questionKey);
        const uniqueQuestionKeys = [...new Set(questionKeys)];
        return uniqueQuestionKeys.length > 0 ? uniqueQuestionKeys : null;
    }

    /**
     * checks for the active tab in dynamic tables
     * @param table the table
     * @returns {string}
     */
    activeTabDynamic(table) {
        let tabActive = `${table.questionId}-total`;

        table.anwser.anwserList.forEach((column) => {
            let colId;
            let rowId;
            let colKey;
            let rowKey;
            let identifier;
            if (column && column.tableIdentifier) {
                colId = column.tableIdentifier.colId;
                rowId = column.tableIdentifier.rowId;
                colKey = column.tableIdentifier.columnKey;
                rowKey = column.tableIdentifier.rowKey;
                identifier =
                    colKey || rowKey
                        ? colKey
                            ? colKey.toString()
                            : "" + rowKey
                                ? rowKey.toString()
                                : ""
                        : (colId ? colId.toString() : "0") + (rowId ? rowId.toString() : "0");
            }
            let subquestionModifiedId = getSubQuestionModifiedId(table.questionId, identifier, rowId, colId);
            if (this.state.tabActive === subquestionModifiedId) {
                tabActive = subquestionModifiedId;
            }
        });

        return tabActive;
    }
}

CollapsibleTableChart.propTypes = {
    questionList: PropTypes.array,
    questionGroups: PropTypes.array,
    missingQuestionGroups: PropTypes.array,
    latestSurveyTemplateName: PropTypes.string,
    latestSurveyTemplateVersion: PropTypes.number,
    surveysByReportingYear: PropTypes.object,
    currentActivePage: PropTypes.string,
    propertyChange: PropTypes.func,
    labelChange: PropTypes.func,
    loadTableDetails: PropTypes.func,
    removeTableDetails: PropTypes.func,
    collapsibleTablesDetails: PropTypes.array,
    expandedQuestionList: PropTypes.array,
    loadTableQuestionDetails: PropTypes.func,
    modalSelectParameters: PropTypes.object,
    removeTableQuestionDetails: PropTypes.func,
    loadQuestionGroupData: PropTypes.func,
    setModalParameter: PropTypes.func,
    getTimeFacetForEvaluation: PropTypes.func,
    timeFacet: PropTypes.object,
    label: PropTypes.array,
    downloadCSV: PropTypes.func,
    downloadProgramCSV: PropTypes.func,
    expandComplexTable: PropTypes.func,
    collapseComplexTable: PropTypes.func,
    collapsibleTablesSubquestionDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    loadTableSubquestionDetails: PropTypes.func,
    clearModalParameter: PropTypes.func
};

export default injectIntl(CollapsibleTableChart);
